import {
  CUSTOMER_LIST_PAGE_REQUEST,
  CUSTOMER_LIST_CUSTOMERS_REQUEST,
  CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST,
  CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL,
  CUSTOMER_LIST_RECEIPT_REQUEST,
  CUSTOMERS_DOWNLOAD_TEMPLATE,
  CUSTOMER_LIST_EXPORT,
  CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY,
  CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST,
  CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST
} from 'actions/customers/list/constants'
import {call, put, takeLatest, takeEvery, cancel} from 'redux-saga/effects'
import * as apiCustomers from 'api/customers'
import * as actCustomerList from 'actions/customers/list'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import {getTransactionDetail} from 'sagas/api/report'
import {getReceiptInvoices} from 'sagas/api/invoices'
import * as actGetExportedFile from 'actions/get-exported-file'
import {LOGOUT} from 'actions/constants'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpCustomerList from 'mixpanel/customers/list'
import fileDownload from 'react-file-download'
import { getSubscriptionStatus } from 'api/feature/getSubscriptionStatus'

export function wait (millis) {
  return new Promise((resolve, reject) => {
    setTimeout(function () {
      resolve(true)
    }, millis)
  })
}
import {showModalImport} from 'actions/uploaders'

export function * pageRequest (request) {
  let customersReqParam = {page: 1}
  mpCustomerList.customerListStart()
  yield put(actCustomerList.setCustomers([]))
  yield put(showPageLoadingSpinner(true))
  let {data} = yield call(getSubscriptionStatus, {'feature_names': ['Loyalty']})
  let hasLoyalty = Boolean(data && data[0] && data[0].is_subscribing)
  if (hasLoyalty) {
    customersReqParam.type = 'ALL'
  }
  yield put(actCustomerList.setHasLoyalty(hasLoyalty))
  yield put(actCustomerList.customersRequest(customersReqParam, []))
  yield put(actCustomerList.setCustomerDetail(null))
}

export function * customersRequest (action) {
  let {payload: {query, previousCustomers}} = action
  let {page, keyword, type} = query
  if (!keyword) {
    keyword = ''
  } else {
    if (keyword[0] === '+') {
      // TODO HACK
      // kalo di mokapos versi lama, input '+62' tidak diencode
      // jadinya '+62' bakal dikirim as is '+62'
      // sementara yang sekarang '+62' bakal diencode jadi '%2B62';
      // karena ngirim '%2B62' bakal error di server (ada tiket PS terkait)
      // jadinya buat mimic pengiriman '+62' insteadof '%2B62'
      // ganti karakter pertama dengan spasi
      // supaya hasil encodingnya '+62'
      query.keyword = ' ' + keyword.substr(1)
    }
  }

  yield put(actCustomerList.closeCustomerDetail())

  try {
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())
    // halt ajax to prevent too fast ajax
    yield call(wait, 300)
    let {data} = yield call(apiCustomers.getCustomers, query)
    let {total_customer, total_loyalty_member, total_rewards_redeemed} = data
    let customers = previousCustomers.concat(data.results)
    yield put(actCustomerList.setCurrentPage(page))
    yield put(actCustomerList.setTotalPage(data.total_pages))
    yield put(actCustomerList.setCustomers(customers))
    yield put(actCustomerList.setKeyword(keyword))
    yield put(actCustomerList.setType(type))
    yield put(actCustomerList.setSummary({total_customer, total_loyalty_member, total_rewards_redeemed}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * customerDetailRequest (request) {
  // noinspection InfiniteLoopJS
  let {payload: {customer, query}} = request
  if (!query) {
    query = {}
  }
  try {
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())

    let {data} = yield call(apiCustomers.getCustomerDetail, customer.id, query)
    if (data) {
      yield put(actCustomerList.setCustomerDetail(data))
      mpCustomerList.customerListSelect({customer: data})
    }

      // show/hide receipt
    $('#customer-detail').show()
    $('#receipt-invoice-customer').hide()
    $('#receipt-transaction-customer').hide()

      // animate
    if ($('#mk-col-left').hasClass('col-sm-12')) {
      $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6')
      setTimeout(function () {
        $('#mk-col-right').fadeIn(200)
        $('[data-toggle="popover"]').popover()
      }, 600)
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * closeCustomerDetail (request) {
  // noinspection InfiniteLoopJS

  yield put(actCustomerList.setCustomerDetail(null))
  // animation
  const toggledClass = 'col-sm-12 col-md-6 col-xs-6'
  $('#mk-col-left, #mk-col-right').removeClass(toggledClass)
  $('#mk-col-left').addClass('col-sm-12')
}

export function * receiptCustomerRequestFlow (request) {
  let {payload} = request
  let paymentType = payload.payment.payment_type
  let parentId = payload.payment.parent_payment_id
  const customer = payload.customer

  $('#customer-detail').hide()

  if (paymentType === 'invoice') {
    let receiptInvoice = yield call(getReceiptInvoices, parentId)
    $('#receipt-transaction-customer').hide()
    $('#receipt-invoice-customer').show()
    yield put(actCustomerList.setReceiptCustomer(receiptInvoice))
    mpCustomerList.customerListSelectPurchaseHistoryInvoice({invoice: receiptInvoice})
  } else {
    let receiptTransaction = yield call(getTransactionDetail, parentId)
    $('#receipt-invoice-customer').hide()
    $('#receipt-transaction-customer').show()
    yield put(actCustomerList.setReceiptCustomer(receiptTransaction))
    mpCustomerList.customerListSelectPurchaseHistoryTransaction({transaction: receiptTransaction, customer})
  }
}

export function * downloadCustomersTemplate (request) {
  let {payload} = request
  try {
    let response = yield call(apiCustomers.getCustomerTemplate)
    if (response.data.message === 'ok') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(payload.filename))
    } else {
      yield put(actNotif.error(response.data.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * getExportCustomer (request) {
  let {payload} = request
  let {fileName, hasLoyalty} = payload
  try {
    yield put(act.sendingRequest(true))
    yield put(act.showLoadingSpinner(true))
    let response = yield call(apiCustomers.getCustomerExport, {hasLoyalty})
    yield call(fileDownload, response.data, `${fileName}.csv`)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.showLoadingSpinner(false))
    yield put(act.sendingRequest(false))
  }
}

export function * customerRedemptionHistoriesRequest (request) {
  let {customerId, ...params} = request.payload.query
  try {
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())

    let {data} = yield call(apiCustomers.getRedemptionHistories, customerId, params)
    yield put(actCustomerList.setRedemptionHistories(data))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * customerPointActivitiesRequest (request) {
  let {customerId, ...params} = request.payload.query
  try {
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())
    let {data} = yield call(apiCustomers.getPointActivities, customerId, params)
    yield put(actCustomerList.setPointActivities(data))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * cancelAction (cancelledTasks, request) {
  yield cancel(...cancelledTasks)
}

export function * changeModalVisibilityFlow (request) {
  yield put(showModalImport(request.payload.modalVisibility))
}

export default function * saga () {
  const customerRequestTask = yield takeLatest(CUSTOMER_LIST_CUSTOMERS_REQUEST, customersRequest)
  const pageReqTask = yield takeLatest(CUSTOMER_LIST_PAGE_REQUEST, pageRequest)
  const customerDetailReqTask = yield takeLatest(CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST, customerDetailRequest)

  yield takeEvery(CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL, closeCustomerDetail)

  const receiptCustomerReqTask = yield takeLatest(CUSTOMER_LIST_RECEIPT_REQUEST, receiptCustomerRequestFlow)
  const downloadCustomersTemplateTask = yield takeLatest(CUSTOMERS_DOWNLOAD_TEMPLATE, downloadCustomersTemplate)
  const exportTask = yield takeLatest(CUSTOMER_LIST_EXPORT, getExportCustomer)

  const redemptionHistoriesRequestTask = yield takeLatest(CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST, customerRedemptionHistoriesRequest)

  const pointActivitiesRequestTask = yield takeLatest(CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST, customerPointActivitiesRequest)

  yield takeEvery(LOGOUT, cancelAction, [
    customerRequestTask,
    redemptionHistoriesRequestTask,
    pointActivitiesRequestTask,
    pageReqTask,
    customerDetailReqTask,
    receiptCustomerReqTask,
    downloadCustomersTemplateTask,
    exportTask
  ])

  yield takeLatest(CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY, changeModalVisibilityFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/customers/list.js